import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { useRef, useState, useEffect } from "react";
import { ScannerRequirement } from "../../services/services";
import { SelectCustom } from "../../components/SelectCustom/SelectCustom";

const scannerOptions = [
  { label: "فعال", value: true },
  { label: "غیرفعال", value: false },
];

const ModalScanner = ({
  showModalScanner,
  setShowModalScanner,
  userIdList = [],
}) => {
  const toast = useRef(null);
  const [isRequired, setIsRequired] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!showModalScanner) {
      setIsRequired(null);
      setLoading(false);
    }
  }, [showModalScanner]);

  const handleHide = () => {
    setShowModalScanner(false);
  };

  const handleSubmit = async () => {
    if (!userIdList || userIdList.length === 0) {
      toast.current?.show({
        severity: "warn",
        summary: "هشدار",
        detail: "ابتدا حداقل یک کاربر را انتخاب کنید",
        life: 3000,
      });
      return;
    }

    if (isRequired === null) {
      toast.current?.show({
        severity: "warn",
        summary: "هشدار",
        detail: "لطفاً وضعیت اسکنر را انتخاب کنید",
        life: 3000,
      });
      return;
    }

    try {
      setLoading(true);

      const body = {
        userIds: userIdList,
        isRequired,
      };

      const res = await ScannerRequirement(body);

      if (res?.errorCode && res.errorCode !== 0) {
        toast.current?.show({
          severity: "error",
          summary: "خطا",
          detail: res?.message || "ثبت تنظیمات انجام نشد",
          life: 3000,
        });
        return;
      }

      toast.current?.show({
        severity: "success",
        summary: "موفق",
        detail: "تنظیمات اسکنر با موفقیت ثبت شد",
        life: 3000,
      });

      setTimeout(() => {
        handleHide();
      }, 800);
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: "error",
        summary: "خطا",
        detail: "مشکل در ارتباط با سرور",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <div
      className="d-flex justify-content-between align-items-center w-100 "
      style={{ gap: "10px" }}
    >
      <Button
        label="بستن"
        icon="pi pi-times"
        className="p-button-text"
        onClick={handleHide}
        style={{
          background: "rgb(187, 31, 31)",
          border: "none",
          color: "#fff",
          padding: "4px",
          margin: "6px",
          borderRadius: "6px",
        }}
      />
      <Button
        label={loading ? "در حال ثبت..." : "ثبت تنظیمات"}
        icon="pi pi-check"
        onClick={handleSubmit}
        loading={loading}
        style={{
          background: "#7cb8ff",
          border: "none",
          color: "#fff",
          padding: "4px",
          margin: "6px",
          borderRadius: "6px",
        }}
      />
    </div>
  );

  return (
    <Dialog
      header="تنظیمات اسکنر"
      visible={showModalScanner}
      style={{ width: "34vw", minWidth: "380px" }}
      modal
      onHide={handleHide}
      footer={footer}
      className="farsi-monospace-digit custom-dialog"
      contentStyle={{
        padding: "1.25rem",
        background: "#1f2937",
        color: "#f3f4f6",
      }}
    >
      <Toast ref={toast} position="top-center" />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div
          style={{
            background: "#2b3648",
            border: "1px solid #3b475c",
            borderRadius: "14px",
            padding: "16px",
            color: "#f3f4f6",
          }}
        >
          <div
            style={{
              fontSize: "13px",
              color: "#b8c1cc",
              marginBottom: "8px",
            }}
          >
            تعداد کاربران انتخاب‌شده
          </div>

          <div
            style={{
              fontSize: "24px",
              fontWeight: "700",
              color: "#ffffff",
            }}
          >
            {userIdList?.length || 0} کاربر
          </div>
        </div>

        <div
          style={{
            background: "#2b3648",
            border: "1px solid #3b475c",
            borderRadius: "14px",
            padding: "16px",
            color: "#f3f4f6",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              marginBottom: "10px",
              color: "#ffffff",
            }}
          >
            وضعیت اسکنر
          </div>

          <SelectCustom
            name="scannerStatus"
            placeholder="وضعیت را انتخاب کنید"
            isClearable={false}
            isSearchable={false}
            unstyled={true}
            options={scannerOptions}
            value={
              scannerOptions.find((item) => item.value === isRequired) || null
            }
            onChange={(e) => {
              setIsRequired(e ? e.value : null);
            }}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ModalScanner;
